import React, { createContext, ReactNode, useContext } from 'react';
import GlobalStyles from '../components/GlobalStyles';
import SolvThemeProvider from '../components/SolvThemeProvider';

type JigsawSettings = {
  history: {
    push: (path: string) => void;
    goBack: () => void;
  };
  analytics?: {
    trackEvent?: (event: string, payload?: any) => void;
  };
};

/**
 * A context containing  settings for Jigsaw
 */
const JigsawContext = createContext<JigsawSettings>({
  history: {
    push: (path) => console.log(`[MOCK] Navigating to ${path}`),
    goBack: () => console.log(`[MOCK] Going back`),
  },
  analytics: {
    trackEvent: (event, payload) =>
      console.log(`[MOCK] Tracking event`, { event, payload }),
  },
});
export default JigsawContext;

type JigsawProviderProps = {
  /** Settings object for jigsaw */
  settings: JigsawSettings;

  /** The children which will receive this context */
  children: ReactNode;
};
export const JigsawProvider = ({ children, settings }: JigsawProviderProps) => {
  if (!settings)
    throw new Error(
      'A JigsawSettings object must be supplied to the JigsawProvider',
    );

  return (
    <JigsawContext.Provider value={settings}>
      <SolvThemeProvider>
        {children}
        <GlobalStyles />
      </SolvThemeProvider>
    </JigsawContext.Provider>
  );
};

export function useJigsaw() {
  const context = useContext(JigsawContext);
  if (!context) {
    throw new Error('A JigsawProvider must be present in the component tree');
  }

  return context;
}

JigsawProvider.displayName = 'JigsawProvider';
